import React, { Component } from 'react'
import { Button } from '../../../components'
import { StyleModal } from './style'
export class ModalCreate extends Component {
  constructor (){
    super()
    this.state = {
      value: ''
    }
  }

  onChangeText = (event) => {
    this.setState({
      value: event.target.value
    })
  }

  submit = ()=> {
    const {
      value
    } = this.state
    const {
      create
    } = this.props
    if(value !== '')
    {
      create(value)
    }
  }

  render () {
    const {
      text,
      name,
      placeholder,
      cancel,
      validate
    } = this.props

    const {
      value
    } = this.state
    return (
      <StyleModal>
        <div className='div-Modal' />
        <div className='content-Modal'>
        <div className='sub-content'>
          <div className='text-modal'>
            {text}
          </div>
          <div className='description'>
            Enter your {name} name
          </div>

          <input
            className={'input'}
            value={value}
            placeholder={placeholder}
            onChange={this.onChangeText}
          />
          {
            validate &&
            <div className='text-error'>
            {validate.description}
            </div>
          }
          <div className='tabel btn-modal'>
            <div className='table-row'>
              <div className='table-cell tabel-right'>
                <Button
                  icon='ic_cancel.svg'
                  name='Cancel'
                  onClick={cancel}
                  className='btn-cancel-modal'
                />
              </div>
              
              <div className='table-cell tabel-left'>
                <Button
                  icon='ic_confirm.svg'
                  name={'Create'}
                  onClick={this.submit}
                  className='btn-confirm'
                />
              </div>
              
            </div>
          </div>
          </div>
        </div>
      </StyleModal>
    )
  }
}